import { Controller } from '@hotwired/stimulus'
import { ContentSequenceBuilder, de, lohrothekAPI } from '@lohro/content-sequence-builder'
import { createApp } from 'vue'

const { apiBaseUrl } = lohrothekAPI.useAPIConfiguration()

apiBaseUrl.value = `${location.origin}/api`

class ContentSequenceBuilderController extends Controller<HTMLDivElement> {
  static values = {
    contentSequenceId: Number,
  }

  declare readonly contentSequenceIdValue: number

  async connect() {
    createApp(ContentSequenceBuilder, {
      contentSequenceId: this.contentSequenceIdValue,
      api: lohrothekAPI,
      i18n: de,
    }).mount(this.element)
    this.element.style.maxWidth = '1280px'
    this.element.style.margin = '0 auto 3rem'
  }
}

export default ContentSequenceBuilderController
